<template>
  <section class="vh-100 d-flex flex-column justify-content-between">
      <div>
        <BusinessesHeader />

        <BusinessesBanner />

        <BusinessesList />
      </div>

      <PageFooter />
  </section>
</template>

<script>
import BusinessesHeader from '../Components/Header'
import BusinessesBanner from '../Components/Banner'
import BusinessesList from '../Components/BusinessesList'
import PageFooter from '@/core/components/PageFooter'

export default {
  components: {
    BusinessesHeader,
    BusinessesBanner,
    BusinessesList,
    PageFooter
  }
}
</script>

<style lang="stylus">
</style>